export const degrees = {
  LEDD: {
    title: 'Licenciatura en Derecho Digital',
    description:
      'Formar profesionistas líderes en el campo del Derecho que afronten y solucionen problemas legales y jurídicos derivados de la continua transformación digital del país.',
    user: 300,
    img: 'https://d1g6c01s9ssd7h.cloudfront.net/img/LicDerechoDigital.jpg',
    link: 'LEDD',
    objective: [
      'La Licenciatura en Derecho Digital de la Universidad de las Ciencias (UDC), tiene tres años de duración en modalidad cuatrimestral y está dirigida a quienes aspiran a formarse en un ámbito emergente de alta demanda en el mercado laboral actual. Está creada para desarrollar un cambio significativo en la vida personal, académica, laboral y profesional de quienes la cursan.',
      'En la Universidad de las Ciencias consolidamos expertos en los diversos campos del Derecho, fortaleciendo habilidades y competencias demandadas que impulsen sus aspiraciones para destacar en su campo profesional.',
      'En la UDC encontrarás una experiencia de aprendizaje única y de calidad acorde a los cambios y exigencias del mundo actual, con metodologías educativas innovadoras, contenidos de vanguardia, actividades creativas y uso significativo de la tecnología.'
    ],
    RVOE: 'RVOE: 2022-119',
    modality: 'en línea',
    duration: 3,
    start: 'enero, mayo, septiembre',
    subjetcs: 54,
    credits: 309,
    academicGrade:
      'Títulación en la Licenciatura en Derecho Digital',
    admissionProfile: [
      {
        description:
          'Quienes aspiren a ingresar a la Licenciatura en Derecho Digital deberán cumplir los requisitos y reunir las características siguientes:',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_003.png',
            text: 'Certificado del nivel Bachillerato, preferentemente en el área de conocimiento: económico - administrativas.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_004.png',
            text: 'Amplio bagaje cultural y un buen manejo de herramientas digitales.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_018.png',
            text: 'Capacidad de análisis, síntesis, de pensamiento abstracto crítico, reflexivo, creativo e innovador; con habilidades de expresión oral y escrita y resolución de problemas.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_021.png',
            text: 'Gusto por la lectura.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_004.png',
            text: 'Interés particular por las problemáticas sociales asociadas a la impartición de justicia general y específicamente a la vinculada con el uso de herramientas digitales.'
          }
        ]
      }
    ],
    graduationProfile: [
      {
        description:
          'El egresado de la Licencitura en Derecho Digital será capaz de:',
        info: [
          {
            text: 'Dominará los elementos teóricos y las herramientas prácticas que le permitan la resolución de problemas jurídicos asociados al ámbito digital, tales como la regulación de la tecnología digital, aspectos en materia de derecho laboral digital, derecho penal digital, litigio digital, derechos digitales (protección de datos personales, ciberseguridad y propiedad intelectual), comercio digital y el gobierno digital desde los diferentes regímenes jurídicos estatales, nacionales e internacionales.'
          },
          {
            text: 'Podrá desempeñarse responsablemente como abogado litigante en materia de derecho digital a fin de defender los derechos digitales de la ciudadanía, tales como asegurar el patrimonio y las transacciones digitales (e-commerce); velar por los derechos de imagen, honor e intimidad; defender la propiedad intelectual y los derechos de creación artística e industrial; proteger ante el ciberbullying, entre otros.'
          },
          {
            text: 'Contará con sólidos conocimientos sobre el marco normativo estatal, nacional e internacional en materia de derechos digitales tales como la protección de datos personales y propiedad intelectual.'
          },
          {
            text: 'Será capaz de promover tanto reformas legales, para adecuar las normas a los avances tecnológicos y progresos de la nación y a los derechos humanos fundamentales, como la resolución ética de los problemas jurídicos en materia de uso de las nuevas tecnologías, sus aplicaciones digitales y telecomunicaciones.'
          },
          {
            text: 'Utilizará adecuadamente técnicas de investigación, herramientas digitales de Tecnología Legal (Legaltech); y fuentes jurídicas especializadas en el Derecho digital (legales, jurisprudenciales, administrativas y doctrinales).'
          },
          {
            text: 'Identificará y aplicará las diferentes herramientas digitales para la comunicación, organización y trabajo colaborativo que favorezcan el desarrollo laboral y emprendimiento.'
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'Cuatrimestre',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Introducción a la Psicología',
          'Psicometría',
          'Bases biológicas de la conducta',
          'Percepción atención y memoria',
          'Fundamentos psicosociales del comportamiento',
          'Desarrollo cognitivo',
          'Psicología y lenguaje',
          'Introducción al estudio del derecho'
        ]
      },
      {
        period: '2º',
        periodText: 'Cuatrimestre',
        subject: [
          'Teorías y sistemas en psicología',
          'Educación de la Sexualidad',
          'Psicología evolutiva',
          'Enfoques de salud y enfermedad',
          'Metodología de la investigación social',
          'Género y psicología',
          'Ética y psicología',
          'Derechos fundamentales'
        ]
      },
      {
        period: '3er',
        periodText: 'Cuatrimestre',
        subject: [
          'Técnicas en psicología I',
          'Métodos en psicología I',
          'Psicología social',
          'Conducta antisocial y delito',
          'Psicopatología',
          'Evaluación psicológica I',
          'Psicología clínica',
          'Personas y familia'
        ]
      },
      {
        period: '4º',
        periodText: 'Cuatrimestre',
        subject: [
          'Técnicas en Psicología II',
          'Métodos en Psicología II',
          'Psicología jurídica',
          'Criminología',
          'Evaluación psicológica II',
          'Intervención psicológica en situación de crisis',
          'Técnicas de la Entrevista y Entrevista Jurídica',
          'Generalidades del derecho penal'
        ]
      },
      {
        period: '5º',
        periodText: 'Cuatrimestre',
        complementary: 'ÁREA DE ESPECIALIDAD',
        subject: [
          'Psicología del testimonio',
          'Mediación y solución de conflictos',
          'Psicología jurídica forense',
          'Victimología',
          'Pericial psicológica',
          'Psicología criminológica',
          'Derecho procesal penal y las etapas de intervención pericial'
        ]
      },
      {
        period: '6º',
        periodText: 'Cuatrimestre',
        subject: [
          'Psicología del interrogatorio',
          'Perfiles psicológicos y  criminológicos',
          'Ciencia forense',
          'Práctica forense pericial',
          'La prueba en el sistema acusatorio en México.',
          'Seminario de tesis e investigación',
          'Medios alternos de solución de controversias y salidas alternas al juicio'
        ]
      },
      {
        period: '7º',
        periodText: 'Cuatrimestre',
        subject: [
          'Derecho Procesal Civil II',
          'Derecho Internacional Privado',
          'Firma, Contratación, Comercio y Probidad por medios electrónicos',
          'Derecho Fiscal',
          'Derechos de las tecnologías: Propiedad industrial e intelectual',
          'Derecho Procesal Laboral'
        ]
      },
      {
        period: '8º',
        periodText: 'Cuatrimestre',
        subject: [
          'Práctica Forense del Juicio Civil',
          'Práctica Forense en Materia de Propiedad Industrial',
          'Marco Regulador de las Empresas Fintech',
          'Medios de Defensa del Contribuyente',
          'Técnicas de Ligitación Oral y Herramientas Tecnológicas',
          'Inglés I'
        ]
      },
      {
        period: '9º',
        periodText: 'Cuatrimestre',
        subject: [
          'Ciberjusticia. Justicia en Línea',
          'Práctica Forense Penal',
          'Ética y Valores Profesionales',
          'Práctica Forense de Amparo',
          'Medios Alternativos de Solución de Controversias',
          'Inglés II'
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/LEDD_NEW.pdf'
      }
    ]
  },
  LPJF: {
    title: 'Licenciatura en Psicología Jurídica Forense (LPJF)',
    description:
      'Impulsando la relación entre la psicología y el derecho basada en evidencia, para la construcción de sociedades más justas',
    user: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LPJF_academia.jpg',
    link: 'LPJF',
    objective: [
      'Nuestro programa de Licenciatura en Psicología Jurídica Forense tiene por objeto ofrecer a la nación profesionistas expertos en la aplicación científica de los métodos y las técnicas de la psicología jurídica en su trayectoria profesional y campo laboral, contribuyendo a la consolidación de las reformas en materia legal, y a la investigación científica del desarrollo humano y social.',
      'Formamos profesionales de la psicología jurídica con conocimientos y competencias para ejercer, con liderazgo, las funciones de estudio (evaluación, investigación, diagnóstico), tratamiento (intervención psicológica individual y colectiva, tratamiento penitenciario, intervención, rehabilitación) y asesoramiento (capacitación, consultoría, evaluación e información, mediación, asesoría sobre programas, medidas y tratamientos) con los más altos estándares técnicos y compromiso social.'
    ],
    RVOE: 'RVOE:2019-123',
    modality: 'Presencial',
    duration: 6,
    start: 'Agosto y Febrero',
    subjetcs: 46,
    credits: 302,
    academicGrade:
      'Título de Licenciada o Licenciado en Psicología Jurídica Forense, registrado ante la SEP',
    admissionProfile: [
      {
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_003.png',
            text: 'De análisis y de síntesis que le permita determinar cuál es el mejor curso de acción frente a situaciones problemáticas y conflictos.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_004.png',
            text: 'De empatía para reconocer y comprender los sentimientos y actitudes de las personas, así como las circunstancias que les afectan en un momento determinado.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_002.png',
            text: 'De reacción efectiva frente a situaciones extremas, con la capacidad de mantener la autorregulación y el autocontrol emocional ante situaciones peligrosas, sorpresivas, extrañas o dramáticas y así poder orientar a los implicados.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_001.png',
            text: 'De mediación y negociación en situaciones de tensión y alto riesgo.'
          }
        ]
      }
    ],
    graduationProfile: [
      {
        itemsInfo: [
          {
            items: [
              'Emplear sus conocimientos sobre las teorías y sistemas tanto de la psicología en general, como de la psicología aplicada en particular.',
              'Actuar de manera ética y responsable ante las exigencias que el medio jurídico plantea.',
              'Ejercer dentro del marco normativo de la conducta utilizando diversas herramientas para evaluarla.',
              'Realizar asesorías técnicamente profesionales con contenido psicológico a personas relacionadas con este campo; actores jurídicos, operadores judiciales, personas en conflicto con la ley, víctimas, procesados, e instituciones relacionadas con la materia.',
              'Desenvolverse de forma fluida en el idioma Inglés para desarrollarse profesionalmente en diversos ámbitos.',
              'Adoptar una actitud práctica y técnicamente robusta para elaborar peritajes psicológicos.',
              'Proponer intervenciones para la prevención del delito y coadyuvar en el ejercicio de la vida jurídica y la clasificación de la conducta legal.',
              'Evaluar conductas en contextos jurídicos y en campos como la psicología forense y la psicología del testimonio, a partir de sus conocimientos para actuar en el sistema acusatorio adversarial derivado de la reciente reforma penal.',
              'Implicarse en procesos de mediación y resolución de conflictos, elaborando perfiles psicológicos, criminológicos y victimológicos del ámbito forense.',
              'Contribuir con los sistemas de protección civil y seguridad ciudadana, atendiendo situaciones de crisis en víctimas del delito, casos de desastre y otros eventos traumáticos que afecten a la población.'
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Introducción a la Psicología',
          'Psicometría',
          'Bases biológicas de la conducta',
          'Percepción atención y memoria',
          'Fundamentos psicosociales del comportamiento',
          'Desarrollo cognitivo',
          'Psicología y lenguaje',
          'Introducción al estudio del derecho'
        ]
      },
      {
        period: '2º',
        periodText: 'SEMESTRE',
        subject: [
          'Teorías y sistemas en psicología',
          'Educación de la Sexualidad',
          'Psicología evolutiva',
          'Enfoques de salud y enfermedad',
          'Metodología de la investigación social',
          'Género y psicología',
          'Ética y psicología',
          'Derechos fundamentales'
        ]
      },
      {
        period: '3er',
        periodText: 'SEMESTRE',
        subject: [
          'Técnicas en psicología I',
          'Métodos en psicología I',
          'Psicología social',
          'Conducta antisocial y delito',
          'Psicopatología',
          'Evaluación psicológica I',
          'Psicología clínica',
          'Personas y familia'
        ]
      },
      {
        period: '4º',
        periodText: 'SEMESTRE',
        subject: [
          'Técnicas en Psicología II',
          'Métodos en Psicología II',
          'Psicología jurídica',
          'Criminología',
          'Evaluación psicológica II',
          'Intervención psicológica en situación de crisis',
          'Técnicas de la Entrevista y Entrevista Jurídica',
          'Generalidades del derecho penal'
        ]
      },
      {
        period: '5º',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA DE ESPECIALIDAD',
        subject: [
          'Psicología del testimonio',
          'Mediación y solución de conflictos',
          'Psicología jurídica forense',
          'Victimología',
          'Pericial psicológica',
          'Psicología criminológica',
          'Derecho procesal penal y las etapas de intervención pericial'
        ]
      },
      {
        period: '6º',
        periodText: 'SEMESTRE',
        subject: [
          'Psicología del interrogatorio',
          'Perfiles psicológicos y  criminológicos',
          'Ciencia forense',
          'Práctica forense pericial',
          'La prueba en el sistema acusatorio en México.',
          'Seminario de tesis e investigación',
          'Medios alternos de solución de controversias y salidas alternas al juicio'
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/LPJF_2022.pdf'
      }
    ]
  },
  LAE: {
    title: 'Licenciatura en Artes Escénicas (LAE)',
    description:
      'Una nueva generación de líderes artísticos en escena',
    user: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LAE_academia.jpg',
    link: 'LAE',
    objective: [
      'El plan de estudios de la licenciatura en Artes Escénicas tiene el propósito de formar licenciados en Artes Escénicas, con competencias para convertirse en artistas escénicos creativos, con habilidades para afrontar las exigencias teatrales y escénicas a través de referentes teóricos, técnicos y prácticos propios de esta disciplina. Formamos profesionales en las artes escénicas con un alto nivel competitivo y de autoexigencia profesional.',
      'Dotados de sólidos conocimientos teóricos y prácticos del teatro y de la danza, los egresados de la Licenciatura en Artes Escénicas serán capaces de participar en la producción de la vida artística y cultural en el estado, el país y en circuitos internacionales, en tanto agentes promotores de la cultura y las artes en los espacios propios para ello. Estarán formados con disciplina técnica, para desarrollarse tanto en  la actuación, como en la dirección, la ejecución escénica, la coreografía y la docencia. Dispondrán de habilidades para la reflexión y la autocrítica, así como para el trabajo en equipo con valores y ética profesional.'
    ],
    RVOE: 'RVOE:2016-097',
    modality: 'Escolarizada',
    duration: 6,
    start: 'Agosto y Febrero',
    subjetcs: 46,
    credits: 301,
    academicGrade:
      'Título de Licenciatura en Artes Escénicas, registrado ante la SEP',
    admissionProfile: [
      {
        description:
          'Quien se interese por formarse en esta licenciatura, debe poseer:',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_003.png',
            text: 'Compromiso e interés por dedicarle tiempo completo a las disciplinas de las artes de alto rendimiento, con especial énfasis en la actuación, el baile clásico y la dirección escénica.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_021.png',
            text: 'De empatía para reconocer y comprender los sentimientos y actitudes de las personas, así como las circunstancias que les afectan en un momento determinado.'
          }
        ]
      },
      {
        description:
          'Además de contar con las siguientes cualidades:',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_017.png',
            text: 'Habilidades corporales como coordinación de movimientos, flexibilidad física, una estructura óseo-muscular sana, alto rendimiento físico para desarrollo de actividades de bajo y alto impacto,, exigencia física y conocimientos básicos de danza en cualquiera de sus géneros.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_009.png',
            text: 'Capacidades creativas: como capacidad de expresarse a partir de la imaginación y mediante estructuras específicas corporales, capacidad rítmica auditiva y capacidad para trabajar en equipo y bajo presión.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_013.png',
            text: 'Actitudes favorables hacia su exposición al público y destreza física para desarrollarla, sensibilidad corporal, destreza verbal tanto oral como escrita, aceptación a la crítica y autocrítica, ser activo, comprometido, y responsable, tener un alto sentido humanista.'
          }
        ]
      }
    ],
    teachers: [
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/gLaguna.png',
        name: 'Ilzkra G. Laguna Morales',
        education: [
          'Maestría en Administración con especialidad en Alta Dirección. UAQ.',
          'Licenciatura en Danza Contemporánea. Universidad Veracruzana.',
          'Licenciatura en Artes Escénicas. - UAQ.',
          'Diplomado en Escenotécnia e Iluminación. Instituto Queretano de la Cultura y las Artes.'
        ],
        description:
          'Bailarina profesional y coreógrafa. Comprometida con el desarrollo integral de los estudiantes, en actualización constante. Con 25 años de experiencia profesional en el ámbito artístico le ha permitido laborar como Coordinadora de Promoción y Difusión proyecto cultura ABACO, Directora artística grupo "ESCENA-prima danza contemporánea", ambas en la Universidad Autónoma de Querétaro, entre otros proyectos.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/osvaldoColil.png',
        name: 'Osvaldo Colil Ibarra',
        description:
          'Actualmente se desempeña como gestor y promotor cultural independiente en INGESTORACULTURA y como productor artístico en la Compañia Oswaldeen AC. Con una amplia experiencia de más de 20 años, se ha hecho acreedor de diversos premios tanto como intérprete como creador escénico; entre ellos el premio internacional: Medalla al reconocimiento y participación al trabajo coreográfico por el Consejo Internacional de la Danza.',
        education: [
          'Licenciatura en Gestión Cultural UDGVIRTUAL.',
          'Licenciatura Colegio Nacional de Danza Contemporánea. Especialidad en Coreografía Ciudad de Querétaro, México.',
          'Cursos y seminarios en técnica Humphrey limón con Ann Vachon Directora en The Limón Institute Offers Classes in Modern Dance.',
          'Cursos intensivos con Oscar Velásquez técnica limón D.F. Geraldine Cardiel curso de Técnica Limón CENADAC.'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/miriamGabriela.png',
        name: 'Miriam Gabriela Correa Juárez',
        description:
          'La Licenciada Miriam Gabriela Correa Juárez, tiene  trayectoria profesional por más de 8 años  como Bailarina Profesional de Ballet Clásico, formó parte de las Compañías Cavalian´s cirque (circo contemporáneo) Danscoreo (danza contemporánea) y Montaje Lamentation. Con amplia experiencia docente en diversas instituciones, actualmente imparte clases en su propio estudio CEDEARTE.',
        education: [
          'Licenciatura en Artes Escénicas, línea terminal Dirección escénica, actuación y danza (Universidad de las Ciencias).',
          'Curso intensivo de ballet clásico (UAQ).'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/normaDaniela.png',
        name: 'Norma Daniela García Cano',
        description:
          'La Licenciada Norma Daniela García Cano, tiene  trayectoria profesional por más de 8 años  como Bailarina Profesional de Ballet Clásico, formó parte de la Compañía de Ballet Clásico de Querétaro “Fernando Jhones” donde se desempeñó como  parte del cuerpo de baile y como solista. Cuenta con una basta experiencia docente en varias instituciones y niveles educativos dentro del Estado.',
        education: [
          'Licenciatura en Artes Escénicas, línea terninal Ballet Clásico (Universidad Autónoma de Querétaro).',
          'Actualmente estudia la Maestría en línea de Educación Especial en la Universidad IEXPRO del Estado de Chiapas.',
          'Curso intensivo de ballet (Consejo Académico de Arte y Danza Internacional).'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/jesusRodolfo.png',
        name: 'Jesús Rodolfo Noyola Resendiz',
        description:
          'Profesor con amplia experiencia como Creador Escénico Audiovisual, colabora como intérprete en diversas compañías, actualmente Anecdotario de la Revolución y Orlando de Tijuana en coordinación con la directora Catal. Desde hace 18 años incursiona en el ámbito de la iluminación, se destacó por 4 años consecutivos como Creador de Espectáculos del Programa Nacional de Teatro Escolar en el Estado de Querétaro, Guanajuato y Chihuahua. Además de generar el Diplomado en Escenotecnia avalado por el Centro Nacional de las Artes. Miembro del Consejo Consultivo de Teatro de la Secretaría de Cultura del Estado de Querétaro.',
        education: [
          'Maestría en Tecnologías de la Información (Universidad Autónoma de  México).',
          'Especialidad en	Tecnologías Educativas (Universidad Autónoma	de México).',
          'Licenciatura en	Artes Escénicas (Universidad Autónoma	de Querétaro).',
          'Técnico	Superior en Actuación (Universidad Autónoma de Querétaro).',
          'Seminario de Dirección Escénica. Patrick Bontè. Residencia Artística. Bélgica.',
          'Módulo I y II del Diplomado en Dirección Escénica. Pátzcuaro.',
          'Diplomado en Artes Digitales (Centro Multimedia del Centro Nacional de las Artes).'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/dalmyVianey.png',
        name: 'Delmy Vianey Muñoz Tavera',
        description:
          'Se ha destacado por su desarrollo profesional como Actriz en diferentes actividades artísticas, Andanzas Teatro-Danza de compañía Línea Vertical,  Obra teatral de leyendas. Delmy Muñoz e Isaías Camacho. Los Cuervos (Empresa Turística) Peña de Bernal, Ezequiel Montes, Qro.  “La Tregua” Adaptación por Jaime Maya. Funciones en Colombia, Bogotá. Temporada en Celaya, Gto.  “La Maquinota” de Ignacio Padilla. Festival Jalpan de Serra. Cuenta con 5 años de experiencia  docente en diferentes niveles educativos.',
        education: [
          'Licenciatura en Artes Escénicas (Actuación) Universidad Autónoma de Querétaro.',
          'Taller Entrenamiento Actoral en un Set Cinematográfico.',
          'Seminario “Dramaturgia del Actor y del Director” (Eugenio Barba Julia Varley).',
          'Taller Suspensión en Telas.',
          'Taller Danza Orissi (Ruy Nieves).'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/fernandoRabell.png',
        name: 'Fernando Rabell Mandujano',
        description:
          'Licenciado Fernando Rabell se  ha destacado por su participación como director y actor  en diferentes Grupos Artísticos, Garito de los Emulantes, El Sótano Teatro (director adjunto), Corral de Comedias (actor),  “México, magia en movimiento», grupo de danza folklórica mexicana residente en Madrid, España. Ha participado en diferentes festivales nacionales e internacionales, Festival de Folklor en Telč, República Checa. (México Folklórico), Habana Vieja, Ciudad en Movimiento; XVI Festival Internacional de Danza en Paisajes Urbanos, la Habana, Cuba; 10º Aniversario de la Escuela Integral de Danzas «El Chúcaro», Pérez, Santa Fe, Argentina. (México Folklórico), 8º Festival Internacional de Folclore, Passo Fundo, RS. Brasil. (Fiesta Mexicana). Se desempeña como docente en diferentes Universidades del Estado.',
        education: [
          'Licenciatura en Danza Escénica (Instituto Universitario de Bellas Artes de la Universidad de Colima).',
          'Cátedra actoral con Demián Bichir en el 19º Festival Internacional de Cine de Guanajuato.',
          'Taller de Teatro-Cabaret, impartido por Roam León, de la Compañía Género Menor, en el Corral de Comedias.',
          'Curso con Pedro García, director de Spacio Cero Colectivo Arte Escénico.',
          'Talleres de Técnica Graham dentro de la VII Convivencia Estudiantil CENADAC, con los maestros Orlando Scheker, Antonia Quiroz, Sergio Pérez, Deyanira Castañeda y Bárbara Alvarado.',
          'Técnica de movimiento a través del trabajo corporal, taller impartido por el maestro Beto Pérez dentro del 4º Frontera Occidente Encuentro de Danza Contemporánea, Colima.'
        ]
      }
    ],
    graduationProfile: [
      {
        description:
          'Quienes egresen de la LAE demostrarán los siguientes conocimientos y habilidades',
        itemsInfo: [
          {
            items: [
              'Actitud responsable y ética en su vida laboral, junto con los conocimientos básicos de Historia del Arte y de las técnicas necesarias alrededor del arte escénico.',
              'Conocimientos para promover la creación de programas de iniciación artística en diversas instituciones de carácter público o privado, generando propuestas de arte escénico.',
              'Conocimientos técnicos, metodológicos y conceptuales en las artes, que le permitan participar en investigaciones aplicadas a los procesos creativos de las artes escénicas.',
              'Habilidades para la danza regional, nacional e internacional y con las destrezas para incorporarse en los medios de producción del arte, la recreación y el entretenimiento.',
              'Habilidades para participar en compañías y montajes de teatro, ballet y de danza profesional, y para participar en proyectos multidisciplinarios de artes escénicas.',
              'Habilidades para dedicarse a la dirección escénica, tanto de teatro como de danza, y para participar en la crítica teatral y cinematográfica en diarios, revistas, suplementos culturales y otros medios de comunicación.',
              'Destrezas para formar compañías de teatro, ballet o danza en el ámbito local, Nacional e Internacional, así como para dirigir a, y actuar en agrupaciones teatrales o cinematográficas, proponer soluciones al desarrollo del Arte Escénico y realizar acciones para impulsar el rescate de la cultura y las tradiciones artísticas de Querétaro y de México.'
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Historia Universal del ArteHistoria Universal del Arte',
          'Técnica del Movimiento Corporal I',
          'Historia del Teatro',
          'Introducción a la Danza',
          'Actuación I. Herramientas de Actuación',
          'Danza Clásica I',
          'Espacio Escénico',
          'Voz y Dicción'
        ]
      },
      {
        period: '2º',
        periodText: 'SEMESTRE',
        subject: [
          'Técnicas del Movimiento Corporal II. Control corporal y desarrollo del movimiento',
          'Análisis de Texto Dramático',
          'Historia de la Danza',
          'Actuación II. Herramientas para la Construcción del Personaje',
          'Danza Clásica II',
          'Danza Folclórica I',
          'Anatomía Humana',
          'Creatividad y Prospectiva'
        ]
      },
      {
        period: '3er',
        periodText: 'SEMESTRE',
        subject: [
          'Escenografía',
          'Actuación III. El cuerpo es escenaActuación III. El cuerpo es escena',
          'Danza Clásica III',
          'Técnica del Movimiento Corporal III',
          'Danza Folclórica II El centro y sur de México',
          'Composición Coreográfica',
          'Música y Canto',
          'Danza Contemporánea I'
        ]
      },
      {
        period: '4º',
        periodText: 'SEMESTRE',
        subject: [
          'Actuación IV. Expresión Corporal',
          'Danza Clásica IV ',
          'Querétaro en su Historia y en la Danza',
          'Dramaturgia',
          'Maquillaje Escénico',
          'Danza Folclórica III. El centro y Norte de México',
          'Danza Contemporánea  II',
          'Diseño y Confección de Vestuario, Accesorios y utilería'
        ]
      },
      {
        period: '5º',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA DE ESPECIALIDAD',
        subject: [
          'Actuación V. El trabajo en la  Puesta en Escena',
          'Danza Clásica V',
          'Danza Española I',
          'Crítica Dramática',
          'Seminario de Investigación',
          'Narración Oral EscénicaNarración Oral Escénica',
          'Danza Contemporánea III',
          'Dirección Escénica I'
        ]
      },
      {
        period: '6º',
        periodText: 'SEMESTRE',
        subject: [
          'Actuación VI.  El actor en la Puesta en Escena',
          'Danza Clásica VI',
          'Danza Española II',
          'Danzas y música de percusiones. África.',
          'Dirección Escénica II',
          'Puesta en escena',
          'Danzas árabes (optativa)',
          'Danzas Brasileñas (optativa)'
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/LAE_2022.pdf'
      }
    ]
  },
  LD: {
    title: 'Licenciatura en Derecho UAQ (LD)',
    description:
      'Formación de vanguardia para los abogados que necesita el México contemporáneo',
    user: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LD_academia.jpg',
    link: 'LD',
    objective: [
      'En la Universidad de las Ciencias, nuestro  programa de Licenciatura en Derecho por la UAQ tiene por objeto formar profesionistas con una pertinente y sólida instrucción en las ciencias jurídicas, altamente valorados en el sector laboral público y privado, reconocidos por su desempeño en los distintos campos que ofrece el ejercicio de su profesión; comprometidos con su entorno social, con competencias comunicativas de criterio jurídico, sustentado en la ética, el desarrollo científico, la metodología multidisciplinaria, interdisciplinaria y transdisciplinaria propia de la filosofía de la ciencias y las humanidades.'
    ],
    RVOE: 'Incorporación de estudios UAQ, acuerdo 2566/2007',
    modality: 'Presencial',
    duration: '4.5 años, 9',
    start: 'Agosto y Enero',
    subjetcs: 60,
    credits: 386,
    academicGrade:
      'Título de Licenciado en Derecho, emitido por la UAQ',
    admissionProfile: [
      {
        description:
          'El aspirante a ingresar a la Licenciatura en Derecho deberá contar con los siguientes conocimientos, actitudes, aptitudes, habilidades y destrezas y, valores.',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_018.png',
            descriptionInfo: 'Conocimientos:',
            list: [
              'En las áreas de ciencias sociales y humanidades.',
              'De fundamentos de investigación científica.',
              'En el uso de métodos y herramientas de investigación básica.',
              'Para el razonamiento lógico-formal y lógico-dialéctico.',
              'Básicos de lengua extranjera (preferentemente inglés).',
              'Generales de TIC´s.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_017.png',
            descriptionInfo: 'Habilidades y destrezas para:',
            list: [
              'La expresión oral y escrita en el ambiente social.',
              'Resolver problemas.',
              'Verbalizar y simbolizar.',
              'Socializar.',
              'Planear y evaluar procesos.',
              'Innovar y crear.',
              'Emprender y tomar decisiones.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_009.png',
            descriptionInfo: 'Valores:',
            list: [
              'Razón y respeto a la persona, a la familia y a la sociedad.',
              'Responsabilidad y compromiso con su entorno social.',
              'Justicia y libertad.Justicia y libertad.',
              'Verdad y respeto.',
              'Orden y disciplina'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_018.png',
            descriptionInfo: 'Aptitudes:',
            list: [
              'Para realizar observación.',
              'Para desarrollar un pensamiento analítico y sintético.',
              'Para establecer analogías.',
              'Formular hipótesis e interpretar.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_021.png',
            descriptionInfo: 'Actitudes:',
            list: [
              'Disposición para aprender y participar.',
              'Ávido conocimientos para su superación.'
            ]
          }
        ]
      }
    ],
    teachers: [
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/jazminElizabeth.png',
        name: 'Mtra. Yazmin Elizabeth Campos Perez',
        education: [
          'Maestra en Derecho Procesal Penal Acusatorio por la Universidad de las Ciencias Jurídicas y Sociales.',
          'Licenciada en Derecho por la Universidad Autónoma de Querétaro.',
          'Diplomado en Derecho de Amparo Indirecto.'
        ],
        description:
          'Con más de diez años de experiencia operando en el sistema legal, tanto en notarías como en despachos y empresas privadas, se ha desempeñado como asistente jurídica, gestora administrativa y consultora prestando servicio jurídicos en materia laboral, mercantil, civil, penal, administrativa y de políticas preventivas generales. Su labor docente la ha desplegado, igualmente en el campo del derecho tanto en la Universidad Autónoma de Querétaro como en la Universidad de las Ciencias Jurídicas y Sociales'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/aronPalacios.png',
        name: 'Mtro. Aarón Palacios González',
        description:
          'El maestro Aarón Palacios González, tiene una amplia experiencia en la aplicación del derecho, ya que ha ejercido como auxiliar y asesor jurídico en diferentes despachos en materia mercantil, laboral, civil, familiar y corporativo. Actualmente se desarrolla de forma independiente dirigiendo su despacho jurídico. En el  campo docente cuenta con una amplia trayectoria a nivel superior.',
        education: [
          'Maestro en Derecho Procesal penal Acusatorio (Universidad de de las Ciencias).',
          'Maestro en Derecho (Universidad Autónoma de Querétaro).',
          'Especialidad en Derecho Notarial (Universidad Autónoma de Querétaro).',
          'Especialidad en Derecho Constitucional y Amparo (Universidad Autónoma de Querétaro).',
          'Licenciado en Derecho (Universidad Autónoma de Querétaro).'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/marcoAntonio.png',
        name: 'Lic. Marco Antonio González Guerrero',
        description:
          'Con más de cinco años de experiencia en diversos despachos jurídicos realizando la gestión  y trámite de  casos en los campos del derecho familiar, penal, laboral, civil, notarial y administrativo. Su experiencia como docente la ha adquirido a lo largo de más de tres años como docente en diversas instituciones de educación superior impartiendo materias como introducción al derecho penal, ciencia política, entre otras.',
        education: [
          'Licenciado en Derecho por la Universidad de las Ciencias Jurídicas y Sociales.'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/edivarHurtado.png',
        name: 'Mtro. Edivar Hurtado Rangel',
        description:
          'Con una vasta experiencia como operador del sistema legal en diversas instancias judiciales realizando labores como Defensor particular y asesor jurídico de víctimas, desahogo de audiencias iniciales, intermedias, de juicio y de individualización de sanciones; elaboración de denuncias y/o querellas; interposición de recursos, medios de impugnación y amparos; consulta y seguimiento a carpetas de investigación, expedientes y documentos en general. Actualmente las realiza como abogado litigante en materia penal desde su despacho jurídico VMGE, Abogados, que combina con su ejercicio como docente, de más de 5 años, en diversas universidades.',
        education: [
          'Maestro en Derecho con énfasis en juicios orales por la Universidad Mondragón México.',
          'Especialista en el sistema Integral de Justicia Penal para Adolescentes por la Universidad de las Ciencias Jurídicas y Sociales.',
          'Licenciado en Derecho por la Universidad Mondragón México.'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/alejandroGarcia.png',
        name: 'Mtro. Alejandro García Maldonado',
        description:
          'Con más de diez años de experiencia como operador en el sistema de justicia se ha desempeñado como Secretario y Auxiliar Jurídico, de causas y salas en diversos Juzgados del Tribunal Superior de Justicia del Estado de Querétaro; a la vez que ha realizado muy diversas actividades como docente a nivel superior e  impartiendo diversos cursos en la materia, como Seminario de Problemas Nacionales, curso taller de Justicia Cívica, Seminario de Amparo, entre otros.',
        education: [
          'Maestro en Derecho Procesal Penal por el  Instituto de Estudios Superiores en Derecho Penal (INDEPAC).',
          'Especialidad en Administración de Justicia. Con actualización en Derecho Penal, por Instituto de Especialización Judicial del Tribunal Superior de Justicia del Estado de Querétaro.',
          'Licenciado en Derecho por la Universidad Autónoma Metropolitana, unidad Azcapotzalco.'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/alvaroJimenez.png',
        name: 'Mtro. Álvaro Jimenez Martínez',
        description:
          'Con más de diez años de experiencia colaborando con diversos despachos jurídicos, actualmente se desempeña como Socio fundador del despacho jurídico Integra Lex Consultores®, especialista en materia laboral. Asesor de diversos sindicatos afiliados a C.T.M., C.R.O.C. y otras centrales obreras a nivel local y federal. A la fecha es asesor y abogado externo del Municipio de Cadereyta de Montes, Querétaro,  asesor externo de la Secretaría del Trabajo del Estado de Querétaro y se desempeñó como asesor externo de diversos funcionarios de la Junta Local de Conciliación y Arbitraje. Tiene amplia experiencia docente en materia legal de nivel superior, actualmente docente de la Universidad de las Ciencias.',
        education: [
          'Licenciatura en Derecho (Universidad de Autónoma de Querétaro).',
          'Curso de actualización Los Límites de la Prevención del Delito.'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/brendaLopez.png',
        name: 'Mtra. Brenda López Guerrero',
        description:
          'Actualmente se desempeña como abogada postulante en materia penal. Su experiencia como operadora del sistema de justicia a lo largo de los últimos 10 años la adquiere desempeñándose como  Secretaria Auxiliar de Acuerdos en el Juzgado Primero en Ejecución de Sanciones Penales; como Meritoria, acordista, y secretaria particular de Juez, encargada de Sala en el  Tribunal superior de Justicia del Estado de Querétaro; además de como auxiliar del bufete jurídico gratuito de la Universidad Autónoma de Querétaro.',
        education: [
          'Maestra en Derecho Procesal Penal Acusatorio, por el Centro de Estudios de Actualización de Derecho. “CEAD”.',
          'Licenciada en Derecho por la Universidad Autónoma de Querétaro.',
          'Diplomado en Criminología y criminalística, una expresión internacional por el Instituto de Capacitación de Seguridad Ciudadana.',
          'Diplomado en Técnicas de Litigación Oral. Impartido en la Universidad Autónoma de Querétaro.'
        ]
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/franciscoJavier.png',
        name: 'Lic. Francisco Javier González Solís',
        description:
          'Con más de diez años de experiencia en el Tribunal Superior de Justicia del Estado de Querétaro, se ha desempeñado como secretario y archivista en  diversos juzgados en materia Civil y Familiar.',
        education: [
          'Licenciado en Derecho por la Universidad Autónoma de Querétaro.',
          'Curso Nueva Ley de Amparo, por el Instituto de Especialización Comercial.'
        ]
      }
    ],
    graduationProfile: [
      {
        description:
          'El licenciado en derecho por la Universidad de Ciencias, contará con los siguientes conocimientos, actitudes, aptitudes, habilidades, destrezas y valores.',
        itemsInfo: [
          {
            descriptionInfo: 'Conocimientos:',
            items: [
              'Profesionales del derecho con bases sólidas en conocimientos jurídicos, formados bajo los principios que rigen los derechos humanos, con dominio de los procesos en materia oral, medios alternos de solución de conflictos, y educados en principios de equidad y perspectiva de género o de origen étnico.',
              'Profesionistas jurídicos con capacidades para realizar funciones de gestión, consulta, asesoría y representación jurídica a particulares e instituciones, ya sean de carácter privado, público o social, dentro de los diferentes ámbitos de competencia: municipal, estatal, federal e internacional.',
              'Profesionales con fundamentos de investigación social, en métodos y técnicas de investigación jurídica, que le permitirán generar bases para evaluar el contexto social, político y económico en el que se vive.'
            ]
          },
          {
            descriptionInfo: 'Actitudes:',
            items: [
              'Formación de profesionistas con una visión humanista de resolución de conflictos a través de medios alternos, logrando acuerdos equitativos que permitan la pronta solución de problemas.',
              'Egresados con actitud de trabajo en equipo con profesionistas de su misma rama u otra disciplina, capaces de comprender los distintos fenómenos sociales, interpretarlos para aportar lo correspondiente a su profesión.',
              'Comprometidos con su entorno social en el que aplican sus habilidades y competencias comunicativas que les permitan desarrollar sus conocimientos jurídicos.'
            ]
          },
          {
            descriptionInfo: 'Aptitudes:',
            items: [
              'Capacitados en realizar investigaciones jurídicas que permiten explicar las teorías y doctrinas que dan sustento a los distintos sistemas y ordenamientos jurídicos, a fin de identificar y proponer soluciones a los problemas de la sociedad contemporánea, en el ámbito local, nacional e internacional.',
              'Egresados con capacidad de diálogo abierto a las distintas posturas para lograr conclusiones incluyentes.'
            ]
          },
          {
            descriptionInfo: 'Habilidades y destrezas:',
            items: [
              'Profesionistas en Derecho con técnicas de interpretación y argumentación jurídica, que demuestren una actitud analítica, juiciosa, novedosa, donde se ve reflejado el dominio del lenguaje jurídico.',
              'Habilidad para identificar y comprender las problemáticas sociales, procesarlas de manera analítica para proponer soluciones jurídicas apegadas al bien común.'
            ]
          },
          {
            descriptionInfo: 'Valores:',
            items: [
              'Profesionistas con respeto y compromiso con los derechos humanos, educados en valores fundamentales como la justicia, la libertad y la verdad.',
              'Egresados que respeten los derechos de las personas que se encuentran relacionados con procesos penales, civiles, laborales, administrativos y constitucionales, entre otros.'
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Introducción al Estudio del Derecho',
          'Historia Universal del Derecho',
          'Lenguaje, lógica y Derecho',
          'Fundamentos de Investigación Social',
          'Derecho Romano',
          'Sociología Jurídica'
        ]
      },
      {
        period: '2º',
        periodText: 'SEMESTRE',
        subject: [
          'Introducción al Derecho Penal',
          'Personas y Familia',
          'Metodología Jurídica',
          'Historia del Derecho Mexicano',
          'Construcción del Pensamiento Jurídico',
          'Ciencia Política'
        ]
      },
      {
        period: '3er',
        periodText: 'SEMESTRE',
        subject: [
          'Teoría del Delito y la Sanción',
          'Bienes y Sucesiones',
          'Teoría del Proceso',
          'Teoría Constitucional',
          'Argumentación Jurídica',
          'Derecho Económico'
        ]
      },
      {
        period: '4º',
        periodText: 'SEMESTRE',
        subject: [
          'Delitos',
          'Obligaciones',
          'Teoría de la Prueba',
          'Derechos Humanos',
          'Derecho Administrativo',
          'Derecho Social',
          'Técnicas de Litigación  Oral'
        ]
      },
      {
        period: '5º',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA DE ESPECIALIDAD',
        subject: [
          'Derecho del Procedimiento Penal Acusatorio',
          'Teoría del Acto Jurídico y Contratos',
          'Derecho Procesal Civil',
          'Derecho Procesal Constitucional',
          'Actividad de la Administración Pública',
          'Derecho Individual del Trabajo',
          'Ética Jurídica y Responsabilidad Profesional'
        ]
      },
      {
        period: '6º',
        periodText: 'SEMESTRE',
        subject: [
          'Justicia restaurativa y Alternativa',
          'Prácticas Aplicadas de Contratos',
          'Sociedades Mercantiles',
          'Amparo',
          'Derecho Fiscal',
          'Derecho Colectivo del Trabajo',
          'Derecho Internacional Público'
        ]
      },
      {
        period: '7º',
        periodText: 'SEMESTRE',
        subject: [
          'Fundamentos de Criminología y Ciencias de la Seguridad',
          'Derecho Notarial y Registral',
          'Títulos y Obligaciones de Crédito',
          'Derecho procesal de Amparo',
          'Derecho Procesal Administrativo',
          'Derecho Procesal del Trabajo',
          'Tratados Internacionales',
          'Prácticas Profesionales'
        ]
      },
      {
        period: '8º',
        periodText: 'SEMESTRE',
        subject: [
          'Filosofía del Derecho',
          'Psicología Jurídica',
          'Derecho Procesal Mercantil',
          'Derecho Ambiental',
          'Derecho de la Seguridad Social',
          'Derecho Agrario',
          'Derecho Internacional Privado',
          'Servicio Social'
        ]
      },
      {
        period: '9º',
        periodText: 'SEMESTRE',
        subject: [
          'Asignatura I Línea terminal de Especialización',
          'Asignatura II Línea terminal de Especialización',
          'Asignatura III Línea terminal de Especialización',
          'Asignatura IV Línea terminal de Especialización',
          'Asignatura V Línea terminal de Especialización',
          'Optativa I'
        ]
      },
      {
        period: '10º',
        periodText: 'SEMESTRE',
        subject: ['Optativa II', 'Seminario de Titulación']
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/LEDUAQ_2022.pdf'
      }
    ]
  },
  LPC: {
    title: 'Licenciatura en Psicología Clínica UAQ (LPC)',
    description: 'Salud mental al servicio de la comunidad',
    user: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/LPC_academia.jpg',
    link: 'LPC',
    objective: [
      'El plan de estudios de la licenciatura en Psicología Clínica tiene como propósito central crear las condiciones de posibilidad para la articulación entre la enseñanza, la construcción del conocimiento y la producción de prácticas de la clínica, basados en los lineamientos metodológicos que guían el quehacer clínico, sus implicaciones éticas con respecto al diseño y aplicación de los instrumentos de intervención con niños, adolescentes, grupos e instituciones, que generen el despliegue de las potencialidades y capacidades de los alumnos de responder y producir demandas de orden clínico, acordes al contexto actual, así como aportes a los debates de la Psicología Clínica.'
    ],
    RVOE: 'Con incorporación de estudios UAQ acuerdo 3656/2007',
    modality: 'Escolarizada',
    duration: 8,
    start: 'Agosto y Enero',
    subjetcs: 52,
    credits: 428,
    academicGrade:
      'Título de Licenciatura en Psicología Clínica, emitido por la UAQ',
    admissionProfile: [
      {
        description:
          'Quien se interese por formarse en esta licenciatura, debe poseer:',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_009.png',
            text: 'Capacidad de asimilación.'
          },
          {
            text: 'Disciplina para el estudio.'
          },
          {
            text: 'Tolerancia en la frustración.'
          },
          {
            text: 'Sensibilidad y estabilidad emocional.'
          },
          {
            text: 'Actitud de honestidad.'
          },
          {
            text: 'Respeto frente al ser humano.'
          },
          {
            text: 'Estar interesado en la problemática y funcionamiento de la conducta del ser humano.'
          }
        ]
      }
    ],
    graduationProfile: [
      {
        description:
          'Quienes egresen de la LPC demostrarán los siguientes conocimientos y habilidades',
        info: [
          {
            text: 'Intervenir psicológicamente en el ámbito clínico dentro del campo de la salud-enfermedad'
          },
          {
            text: 'Diseñar e implementar proyectos y programas de prevención, detección, orientación y atención, de manera individual o grupal en el campo de la psicología clínica  en instituciones públicas y privadas'
          },
          {
            text: 'Abordar clínicamente problemáticas que emergen en la infancia y adolescencia'
          },
          {
            text: 'Acompañar desde una perspectiva psicoterapéutica a pacientes en situaciones hospitalarias, así como a su familia'
          },
          {
            text: 'Manejar y diseñar instrumentos de evaluación psicodiagnóstica desde una perspectiva crítica'
          },
          {
            text: 'Diseñar programas de educación en el campo de la sexualidad.'
          },
          {
            text: 'Coordinar grupos configurados con objetivos clínicos'
          },
          {
            text: 'Diseñar protocolos y desarrollar procesos de investigación'
          },
          {
            text: 'Capacidad crítica a partir del estudio de la construcción teórica del Psicoanálisis, su historia y debates teóricos con otros paradigmas psicológicos y de otras disciplinas'
          },
          {
            text: 'Reconocer las modalidades de extensión del Psicoanálisis, sus límites y potencialidades clínicas'
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Introducción a la Psicología',
          'Psicofisiología',
          'Epistemología',
          'Enfoques en Salud Enfermedad',
          'Historia y Sociedad I',
          'Educación de la Sexualidad'
        ]
      },
      {
        period: '2º',
        periodText: 'SEMESTRE',
        subject: [
          'Historia General de La Psicología I',
          'Desarrollo Cognoscitivo',
          'Métodos en Psicología I',
          'Teoría de Grupos',
          'Historia y Sociedad II',
          'Personalidad y Desarrollo'
        ]
      },
      {
        period: '3er',
        periodText: 'SEMESTRE',
        subject: [
          'Historia General de Psicología II',
          'Introducción al Psicoanálisis I',
          'Métodos en Psicología II',
          'Técnicas en Psicología I',
          'Cultura y Sociedad en México',
          'Psicología de la Educación'
        ]
      },
      {
        period: '4º',
        periodText: 'SEMESTRE',
        subject: [
          'Psicología y Lenguaje',
          'Introducción al Psicoanálisis II',
          'Seminario de Investigación',
          'Técnicas en Psicología II',
          'Subjetividad y Orden Social',
          'Psicología de las Organizaciones'
        ]
      },
      {
        period: '5º',
        periodText: 'SEMESTRE',
        complementary: 'ÁREA DE ESPECIALIDAD',
        subject: [
          'Historia del movimiento psicoanalítico I',
          'Psicopatología descriptiva.',
          'Antecedentes del método psicoanalítico.',
          'Investigación I',
          'Introducción a los campos de intervención clínica',
          'Introducción al trabajo clínico con niños',
          'Introducción al diagnóstico clínico'
        ]
      },
      {
        period: '6º',
        periodText: 'SEMESTRE',
        subject: [
          'Historia del movimiento psicoanalítico II',
          'Conceptos generales de psicopatología dinámica',
          'Método psicoanalítico I',
          'Investigación II',
          'Prácticas clínicas I',
          'Introducción al trabajo clínico con adolescentes.',
          'Diagnóstico clínico'
        ]
      },
      {
        period: '7º',
        periodText: 'SEMESTRE',
        subject: [
          'Teoría psicoanalítica I',
          'Psicopatología dinámica: la neurosis',
          'Método psicoanalítico II',
          'Investigación III',
          'Prácticas clínicas II',
          'Clínica grupal I',
          'Diagnóstico Institucional'
        ]
      },
      {
        period: '8º',
        periodText: 'SEMESTRE',
        subject: [
          'Teoría psicoanalítica II',
          'Psicopatología dinámica: perversión y psicosis',
          'Método psicoanalítico III',
          'Investigación IV',
          'Prácticas clínicas III',
          'Clínica grupal II',
          'Diseño de propuestas de intervención clínica'
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/LPCUAQ2022.pdf'
      }
    ]
  }
};

export const postgraduates = {
  ESIJPA: {
    title:
      'Especialidad en Sistema Integral de Justicia Penal para Adolescentes (ESIJPA)',
    description:
      'Posgrado para una nueva generación de Líderes en Procuración de Justicia para Adolescentes',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/ESIJPA_academia.jpg',
    link: 'ESIJPA',
    objective: [
      'La Especialidad en Sistema Integral de Justicia Penal para Adolescentes está dirigida a personas interesadas en el desarrollo psicosocial del adolescente, en la búsqueda de alternativas para disminuir los índices delictivos y en la procuración de justicia para este grupo poblacional.  El egresado de la especialidad, tendrá un perfil idóneo para ejercer su profesión en las diversas áreas del sistema integral de justicia penal para adolescentes y para abordar problemas sociales a través de la investigación, así como para participar en la administración de la justicia pública o privada.'
    ],
    RVOE: 'RVOE: 2022-008',
    modality: 'Modalidad en línea',
    duration: 2,
    start: 'Agosto y Febrero',
    subjetcs: 12,
    credits: 45,
    academicGrade:
      'Diploma de Especialidad en Sistema Integral de Justicia Penal para Adolescentes, registrado ante la SEP.',
    admissionProfile: [
      {
        description:
          'El interesado en realizar la Especialidad en el Sistema Integral de Justicia Penal para Adolescentes, deberá contar con estudios terminados de Licenciatura en  las áreas  de  Derecho,  Psicología,  Sociología,  Trabajo  Social, Medicina,  Criminología,  Política Criminal u otras áreas afines del conocimiento social. Deberá tener interés en conocer el desarrollo psicosocial del adolescente, así como en la política criminal con el propósito de buscar alternativas para disminuir el índice de criminalidad entre esta población.Además, resulta recomendable contar con las siguientes cualidades: ',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/perfil_04.png',
            descriptionInfo: '',
            text: [
              'Habilidades para expresarse en forma oral y escrita, para argumentar, analizar, proponer alternativas y refutar cuando sea necesario.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/perfil_03.png',
            descriptionInfo: '',
            text: [
              'Capacidades de reflexión ante dilemas ético-jurídicos; para trabajar en equipo, para brindar solución a casos concretos; de analizar situaciones y casos prácticos, de realizar investigación documental y de campo; de aceptación a la crítica y de autocrítica; de adaptación a diversos ambientes de aprendizaje en la lógica del respeto a la diversidad y pluralidad de ideas, así como una actitud crítica y propositiva frente a los grandes problemas derivados del campo del saber específico del Derecho.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/perfil_02.png',
            descriptionInfo: '',
            text: [
              'Actitudes de compromiso con los valores, la justicia y el bien común, y sensibilidad ante las conductas realizadas por el adolescente. De respeto y valoración de la vida humana y los derechos humanos, por la creatividad humana y el aprendizaje; por los principios procesales y el debido proceso; por los derechos de niñas, niños y adolescentes.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/perfil_01.png',
            descriptionInfo: '',
            text: [
              'Fortalezas  como destreza mental, seguridad, proactividad, compromiso y responsabilidad; cultivar un alto sentido humanista y gusto por la lectura.'
            ]
          }
        ]
      }
    ],
    graduationProfile: [
      {
        itemsInfo: [
          {
            items: [
              'Conocimientos para desempeñarse en el nuevo Sistema Integral de Justicia Penal para Adolescentes y para actuar con responsabilidad profesional y sentido ético.',
              'Dispondrá de los conocimientos especializados sobre el desarrollo del adolescente desde el ámbito biológico, social, psicológico y el desarrollo del derecho. Conocerá, analizará y será capaz de proponer políticas públicas para disminuir la delincuencia juvenil.',
              'Capacidad de operar en el sistema acusatorio adversarial y de desarrollarse profesionalmente en el litigio penal.',
              'Conocimientos de victimología y habilidades para la investigación jurídica y la criminología.',
              'Conocimiento de los roles y técnicas de los intervinientes en el proceso, y dispondrá de las destrezas necesarias para la litigación oral.',
              'Conocimiento del marco normativo que regula el derecho internacional, tratados y convenciones.',
              'Conocimiento de la nueva estructura del procedimiento penal y las buenas prácticas en materia de transparencia y rendición de cuentas en la justicia penal mexicana.',
              'Capacidad de abordar problemas socio-jurídicos en la administración de la justicia pública o privada.'
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'Semestre',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Conceptualización de la Adolescencia y Marco Normativo',
          'Principios rectores del Sistema Integral de Justicia Penal para Adolescentes',
          'Desarrollo físico en la adolescencia',
          'El desarrollo y la evaluación psicológica en los adolescentes',
          'Adolescencia y sociedad',
          'Procedimiento acusatorio adversarial en adolescentes'
        ]
      },
      {
        period: '2º',
        periodText: 'Semestre',
        subject: [
          'Técnicas para la investigación jurídica en el sistema de adolescentes',
          'Soluciones Alternas y Formas de Terminación Anticipada',
          'Justicia para el adolescente, la víctima y los derechos humanos',
          'Ejecución de medidas de sanción',
          'Recursos y amparo en el sistema de adolescentes',
          'Práctica Forense en el Sistema de Justicia para Adolescentes'
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/ESIJPA_2022.pdf'
      }
    ]
  },
  EEPF: {
    title: 'Especialidad en Evaluación Psicológica Forense (EEPF)',
    description:
      'Psicología Aplicada para fortalecer el Sistema de Justicia',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/EEPF_academia.jpg',
    link: 'EEPF',
    objective: [
      'Contribuir a la consolidación del Sistema Acusatorio Adversarial, especializando profesionistas del área de la psicología a fin de que dispongan de los conocimientos y competencias que demanda este nuevo sistema, así como formar especialistas en evaluación psicológica forense, para la adecuada elaboración de dictámenes periciales de víctimas y victimarios implicados en fenómenos tales como: la violencia de género, la imputabilidad, el régimen de guarda y custodia de menores, la tortura física y psicológica, los delitos sexuales, la violencia familiar, la credibilidad del testimonio, el daño moral y psicológico, la incapacidad laboral y otras conductas asociadas a los campos  legal y jurídico.'
    ],
    RVOE: 'RVOE: 2022-009',
    modality: 'Modalidad en línea',
    duration: 2,
    start: 'Agosto y Febrero',
    subjetcs: 12,
    credits: 45,
    academicGrade:
      'Diploma de Especialidad en Evaluación Psicológica Forense, registrado ante la SEP.',
    admissionProfile: [
      {
        description:
          'El aspirante a ingresar a la Especialidad en Evaluación Psicológica Forense de la Universidad de las Ciencias, deberá cumplir los requisitos y reunir las características siguientes:',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/perfil_EEPF_04.png',
            descriptionInfo: '',
            text: ['Licenciatura en Psicología.']
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/perfil_EEPF_03.png',
            descriptionInfo: '',
            text: [
              'Conocimientos teórico-prácticos básicos para el desempeño exitoso de sus actividades profesionales en el campo de las ciencias forenses y periciales.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_009.png',
            descriptionInfo: '',
            text: [
              'Interés en la adquisición de conocimiento teórico y práctico de la psicología aplicada a las ciencias jurídicas y forenses.'
            ]
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/perfil_EEPF_02.png',
            descriptionInfo: '',
            text: [
              'Conocimientos básicos de evaluación psicológica.'
            ]
          }
        ]
      }
    ],
    graduationProfile: [
      {
        description:
          'El egresado de la Especialidad en Evaluación Psicológica Forense (EEPF) por la UDC',
        itemsInfo: [
          {
            items: [
              'Será capaz de evaluar, prevenir, asesorar, tratar y estudiar aquellos fenómenos psicológicos, conductuales y relacionales que inciden en el comportamiento legal de las personas, mediante la utilización de métodos propios de la psicología científica y cubriendo distintos ámbitos y niveles de estudio e intervención.',
              'Identiﬁcará y aplicará las diferentes técnicas de investigación jurídica y forense en el desarrollo de sus investigaciones mediante la aplicación de herramientas de análisis que les permita comprender las complejidades de la práctica pericial psicológica, desempeñarse con un ejercicio profesional responsable y favorecer la lectura crítica acerca de las modalidades de intervención del psicólogo en el ámbito jurídico, a través del análisis de casos y la asistencia a juicios orales.',
              'Reconocerá los factores psicológicos subyacentes a la delincuencia, la vinculación de algunos trastornos mentales con conductas criminales, su diagnóstico y evaluación.',
              'Conocerá los aspectos básicos de la bioética y su relación con la profesión, así como las formas de comportamiento que debe asumir el psicólogo en la investigación, diagnóstico, intervención y evaluación de estas problemáticas.',
              'Podrá establecer si la víctima de un hecho punible presenta un cuadro de sintomatología mental derivado que pueda considerarse daño moral o psicológico, a ﬁn de orientar a la autoridad en la búsqueda del restablecimiento del estado previo de la persona, en el marco de un proceso penal, civil o administrativo, con ﬁnes de indemnización, conciliación o reparación.',
              'Dominará los métodos y técnicas adecuadas para realizar la evaluación psicológica de los casos en que se alegue  tortura de acuerdo a normas y protocolos vigentes.',
              'Comprenderá que la violencia de género es una de las formas más graves de discriminación que sufren las mujeres, y dispondrá de instrumentos técnicos y metodológicos para establecer la evidencia cientíﬁca que acredite su existencia.',
              'Dominará instrumentos y técnicas de valoración de abuso a menores y víctimas de violación, y será capaz de proponer métodos y programas de intervención en casos de abuso sexual. '
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'Semestre',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Evaluación Psicológica Forense',
          'Peritaje Psicológico Forense',
          'Psicometría y Psicopatología Forense',
          'Técnicas de la Investigación Jurídico Forense',
          'Evaluación Psicológica Forense para Guarda y Custodia',
          'Evaluación Psicológica Forense de la Inimputabilidad'
        ]
      },
      {
        period: '2º',
        periodText: 'Semestre',
        subject: [
          'Ética Jurídica Forense',
          'Evaluación Psicológica Forense de la Tortura',
          'Evaluación Psicológica Forense de la Violencia de Género',
          'Evaluación Psicológica Forense a Víctimas de Delitos Sexuales',
          'Evaluación Psicológica Forense del Daño Moral o Psicológico ',
          'El Informe Psicológico Pericial y la Práctica Forense'
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/EEPF_2022.pdf'
      }
    ]
  },
  MPJF: {
    title: 'Maestría en Psicología Jurídica Forense (MPJF)',
    description:
      'Una Nueva Generación de Líderes en la Psicología Jurídica Forense',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/MPJF_academia.jpg',
    link: 'MPJF',
    objective: [
      'La Maestría en Psicología Jurídica Forense comprende al estudio, explicación,  evaluación, prevención, asesoramiento y tratamiento de los fenómenos psicológicos conductuales que inciden en el comportamiento legal de las personas. El objeto principal de estudio es el comportamiento de los actores jurídicos en el ámbito del derecho, las leyes y el sistema de justicia en general; profundizando en la victimología, la psicología de la delincuencia y los procesos de mediación, y con especial relevancia en la psicología de la víctima y del agresor en relación con los  derechos civil, penal y laboral.'
    ],
    RVOE: 'RVOE: 2018-011',
    modality: 'Presencial',
    duration: 4,
    start: 'Agosto y Febrero',
    subjetcs: 20,
    credits: 75,
    academicGrade:
      'Título de Maestría en Psicología Jurídica Forense, registrado ante la SEP.',
    admissionProfile: [
      {
        description:
          'El interesado en participar en el programa debe poseer: ',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_018.png',
            text: 'Licenciatura en Psicología, Derecho, Criminología, Ciencias Penales, Ciencias de la Seguridad, Trabajo Social o ser Perito en Psicología Acreditado.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_021.png',
            text: 'Interés en la adquisición de conocimiento teórico y práctico de la psicología aplicada en las ciencias jurídicas y forenses.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_004.png',
            text: 'Conocimientos teórico-prácticos básicos para el desempeño exitoso de sus actividades profesionales en el campo de las ciencias forenses y periciales.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_017.png',
            text: 'Conocimientos básicos de evaluación psicológica.'
          }
        ]
      },
      {
        description:
          'Además de contar con las siguientes cualidades:',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_002.png',
            text: 'Habilidades para asesorar, establecer empatía, realizar entrevistas, para saber reaccionar frente a situaciones extremas, de investigación, y para revisar, interpretar y redactar de forma crítica, textos científicos e informes profesionales'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_001.png',
            text: 'Capacidades para presentar pruebas, de análisis y de síntesis, para  la percepción de detalles; para la mediación, la conciliación y la negociación.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_009.png',
            text: 'Aptitudes favorables para sustentar y defender elementos probatorios y exponerlos de manera persuasiva, y una clara orientación a la protección de los derechos humanos y la observancia de los principios éticos profesionales.'
          }
        ]
      }
    ],
    teachers: [
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/arelyOliva.png',
        name: 'Dra. Arely Oliva Alvarado',
        education: [
          'Doctora en Salud Mental.',
          'Maestra en Psicología Jurídica Forense por la Universidad de las Ciencias Jurídicas y Sociales.',
          'Licenciada en Psicología Clínica por la Universidad Autónoma de Querétaro.',
          'Curso de Prevención de las violencias contra las adolescencias. CNDH.',
          'Curso de Investigación con perspectiva de género sobre la tortura sexual contra las mujeres. CNDH, entre otros.'
        ],
        description:
          'Labora en la Dirección de Atención a Víctimas de Violencia Familiar y de Género de la Secretaría de Seguridad Pública del Municipio de Querétaro, cuenta con una amplia experiencias en labores de brindar atención especializada y respuesta oportuna a incidentes de violencia familiar y de género, mediante la orientación, atención en crisis y acompañamiento psicológico en situaciones que así lo requieran. También ha colaborado en  el Centro Integral de Prevención Social III, realizando actividades en materia de prevención social de la violencia y la delincuencia en instituciones, y brindando terapia individual y grupal a población en riesgo.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/albertoRafael.png',
        name: 'Dr. Alberto Rafael Buendía Madrigal',
        education: [
          'Lic. En Criminología por la Universidad Autónoma de Querétaro.',
          'Mtro. Psicología Jurídica y Forense. Universidad de las Ciencias Jurídicas y Sociales.',
          'Mte. Criminología, Criminalística e Investigación Criminal. Instituto Superior de Ciencias de Ciudad Juárez.',
          'T.S.U. en Investigación Policial, Policía con capacidades para procesar la escena del crimen, PGJ Querétaro, México.',
          'Perfilador Criminal por El Colegio Mexicano de Ciencias Forenses.',
          'Diplomado Sistema Penal Acusatorio Adversarial- Facultad de Derecho UAQ.',
          'Diplomado en Perfilación Criminal por el CMCF.'
        ],
        description:
          'Doctorante en Derecho por la Universidad de Salamanca en España, asi como Maestro en Ciencias Penales (UNAM) y en Derechos Humanos (UAQ). Su vasta experiencia en el sector público demuestran el gran conocimiento que ha adquirido a lo largo de los años y que lo ha llevado a impartir clases, conferencias, simposios, entre otros. Fue Agente del Ministerio Público  desde 1997 hasta 2008. A partir del 2008 todos los puestos en los que ha fungido han sido como director o delegado. Actualmente se dedica a la impartición de clases y es titular del Centro de Atención Integral de la Comisión Ejecutiva de Atención a Víctimas en el Estado de Querétaro.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/omarAlejandro.png',
        name: 'Mtro. Omar Alejandro Hernández Valdez',
        education: [
          'Lic. En Criminología por la Universidad Autónoma de Querétaro.',
          'Mtro. Psicología Jurídica y Forense. Universidad de las Ciencias Jurídicas y Sociales.',
          'Mte. Criminología, Criminalística e Investigación Criminal. Instituto Superior de Ciencias de Ciudad Juárez.',
          'T.S.U. en Investigación Policial, Policía con capacidades para procesar la escena del crimen, PGJ Querétaro, México.',
          'Perfilador Criminal por El Colegio Mexicano de Ciencias Forenses.',
          'Diplomado Sistema Penal Acusatorio Adversarial- Facultad de Derecho UAQ.',
          'Diplomado en Perfilación Criminal por el CMCF.'
        ],
        description:
          'Actualmente se desempeña en la Unidad de Análisis e Inteligencia Policial  en la Secretaría de Seguridad Pública del Municipio de Corregidora de Querétaro realizando labores de investigación, vinculación de casos, detección de activos seriales del delito, especialista en la elaboración de perfiles geográficos, analista estadístico, espacial, y temporal del delito. Líder del proyecto ganador en el 9° concurso internacional de análisis delictual 2020, organizado por la Asociación Internacional de Analistas Criminales (IACA) y fundación Paz Ciudadana de Chile, con el proyecto del “Observatorio Vial del Municipio de Corregidora”.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/monicaManzano.png',
        name: 'Mtra. Mónica Manzano Aveldaño',
        education: [
          'Maestra en Psicoterapia Psicoanalítica, por la Asociación Psicoanalítica Mexicana.',
          'Diplomada en Psicología Forense por la Universidad Autónoma de México.',
          'Diplomada en Criminología por el Colegio Libre de Estudios Universitarios.',
          'Licenciada en Psicología por la Universidad de las Américas.'
        ],
        description:
          'A su trayectoria como psicoterapeuta privada, suma su experiencia colaborando con diversas instituciones como el Instituto Nacional de Psiquiatría de la Fuente Muñiz, el Centro Preventivo de Readaptación Social Varonil Sur, la Comunidad de Tratamiento para Adolescentes en Conflicto con la Ley Alfonso Quiróz Cuarón, o el Centro de Atención a Víctimas de Delitos Violentos de la PGR, en la que se ha especializado en el campo de la criminología y la victimología. Es socia fundadora de la Barra de Juristas de México, Colegio Profesional AC. Certificada como Perito particular.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/joseManuel.png',
        name: 'Dr. José Manuel Bezanilla Sánchez Hidalgo',
        education: [
          'Doctor en Ciencias para la Familia.',
          'Maestro en Ciencias de la Educación Familiar por ENLACE A.C.',
          'Especialidad en Psicoterapeuta de grupos y Director de Psicodrama Clínico. en el Centro de Estudios Psicodramáticos (CEPSI).',
          'Especialidad en “Tratamiento de Adicciones con Acupuntura” Avalada por Especialistas en Adicciones A.C. y por la National Acupuncture Desintoxication Assiociation (NADA).',
          'Licenciado en Psicología por la Universidad del Valle de México Campus Tlalpan.'
        ],
        description:
          'Doctor en Ciencias para la Familia.  Psicólogo, con formación en psicoterapia de grupos y psicodrama. Cuenta con más de 10 años de experiencia en Derechos Humanos con víctimas de tortura y otras violaciones graves en esta materia. Presidente fundador de Psicólogos Sin Fronteras México hasta junio de 2020. Ha participado en diversos estudios clínicos como especialista para la elaboración del CIE 11 de la OMS, publicado diversos libros y artículos sobre Psicodrama, Derechos Humanos y Perspectiva Psicosocial, documentación psicológica de la Tortura y Psicología Profunda; actualmente se desempeña como Visitador Adjunto de la CNDH.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/irisMoreno.png',
        name: 'Mtra. Iris Moreno Oliva Alvarado',
        education: [
          'Maestra en Psicoterapia Ericksoniana por el Instituto Milton Erickson de México.',
          'Licenciada en Psicología, por la Universidad Autónoma de Querétaro.',
          'Diplomada en Psicología Forense con Enfoque Psicosocial, por el Instituto Ciencia Aplicada.',
          'Certificación en Psicología Forense con Enfoque Psicosocial y Derechos Humanos.'
        ],
        description:
          'A su trayectoria como Psicoterapeuta y perito particulares, suma su experiencia como docente en la Universidad Autónoma de Querétaro, en la carrera de Criminología, en el Instituto del Servicio Profesional de Carrera, en la Fiscalía General de Estado de Querétaro y en el Centro de Capacitación, Formación e Investigación para la Seguridad. (CECAFIS). Además se ha desempeñado como jefa del Área de Psicología en la Comisión Estatal de Atención Integral a Víctimas.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/jesusManuel.png',
        name: 'Mtro. Jesús Manuel Ramírez Escobar',
        education: [
          'Doctorante en Psicología y Maestro en Psicoanálisis por la Universidad de Buenos Aires.',
          'Maestrante en Educación por las Universidad Pedagógica Veracruzana.',
          'Licenciado en Psicología por la Universidad Veracruzana.'
        ],
        description:
          'Se ha desempeñado como analista de prevención social del delito y Jefe de la Unidad de Atención Especializada a Víctimas del Delito, dependiente de la Dirección Ejecutiva de Atención a Víctimas de la Secretaría de Seguridad Ciudadana del Estado de Querétaro. Con cerca de diez años de experiencia como docentes en diversas universidades públicas y privadas.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/angelicaMedina.png',
        name: 'Mtra. Angélica Medina Filoteo',
        education: [
          'Maestra en Psicología Jurídica Forense, por la Universidad de las Ciencias Jurídicas y Sociales.',
          'Licenciada en Psicología por la Universidad Quetzalcoatl de Irapuato.',
          'Diplomada como Perito Profesional en Psicología Forense.',
          'Diplomada en Mente Suicida por el Sistema para el Desarrollo Integral de la Familia del Estado de Guanajuato y la Asociación Mexicana de Suicidiología en la Cd. de León, Gto.',
          'Diplomada en Programación Neurolingüística.'
        ],
        description:
          'Directora de CEAPSI S. C. desde hace más de cinco años. Funciones que combina con su ejercicio profesional como psicóloga en tareas de atención psicológica a niños, niñas, adolescentes, jóvenes y adultos; terapia individual, familiar y de pareja;  aplicación de evaluaciones psicométricas para selección de personal; facilitadora de talleres vivenciales, de capacitación laboral y escolar, en diversos temas. Evaluaciones de psicodiagnóstico escolar y peritajes psicológicos en materia familiar. Perito en Materia de Psicología, autorizada por el Poder Judicial del Estado de Guanajuato, e integrante de la lista de peritos autorizados por el Poder Judicial Federal.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/fabiolaElenka.png',
        name: 'Dra. Faviola Elenka Tapia Mendoza',
        education: [
          'Doctora en en Política Criminal, Centro Jurídico Universitario.',
          'Maestra en Política Criminal, Instituto Nacional de Ciencias Penales.',
          'Licenciada en Relaciones Internacionales, Universidad del Valle de México.',
          'Licenciada en Derecho, Universidad del Valle de México.',
          'Licenciada en Psicología Universidad Nacional Autónoma de México.'
        ],
        description:
          'Ha colaborado en el Poder Legislativo de la Ciudad de México como asesora en asuntos internacionales y seguridad pública, fue profesora–investigadora y subdirectora del servicio profesional de carrera en el Instituto de Formación Profesional de la PGJDF, desde 2015 labora en la Comisión Nacional de los Derechos Humanos como visitadora adjunta, en temas penitenciarios y en la evaluación forense de violaciones a derechos humanos en la Coordinación General de Especialidades Científicas y Técnicas. También ha sido catedrática en diversas universidades.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/juventinnodeJesus.png',
        name: 'Mtro. Juventino de Jesús Hernández Montes',
        education: [
          'Maestro en Derecho Procesal Penal Acusatorio.',
          'Licenciado Derecho Privado.',
          'Diplomado en  Capacitación para jueces y magistrados (Academia Regional de  Seguridad Pública del Sureste).',
          'Argumentación jurídica y la aplicación del derecho, (Centro de Estudios de Actualización en Derecho).',
          'Certificación en justicia para adolescentes (Escuela Judicial del Instituto de la Judicatura Federal).'
        ],
        description:
          'Secretario Proyectista de segunda instancia de la Primera Sala Civil, se ha desarrollado en diferentes funciones dentro  del Tribunal Superior de Justicia como Secretario Proyectista, adscrito en su momento a la extinta Sala Electoral, después a la otrora  Segunda Sala Penal, Secretario Auxiliar, Actuario Municipal, Actuario de Primera Instancia de Tequisquiapan  y Secretario Técnico del Consejo Distrital IX. Tiene cinco años de experiencia como docente a nivel licenciatura  y posgrados.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/alfonsoOrtega.png',
        name: 'Mtro. Alfonso Ortega Carrillo',
        education: [
          'Maestro en Criminalística por el Instituto Nacional de Ciencias Penales.',
          'Licenciado en Psicología por la Facultad de Estudios Superiores - Zaragoza.',
          'Diplomado en Herramientas para la Evaluación Psicovictimal en el Ámbito Forense.',
          'Diplomado en Investigación Psicocriminodelictiva.',
          'Diplomado  en Psicología Forense.'
        ],
        description:
          'Con más de diez años de experiencia como Analìsta Técnico  del Centro de Reclutamiento y Capacitación “Sub Oficial José Ramos López” y de la Dirección de Supervisión y Evaluación Corporativa de la Secretaría de Seguridad Pública de la Ciudad de México realizando actividades de Evaluación psicológica para la selección de personal operativo y administrativo, en la promoción de puestos, ascensos, mandos medios, servicios especiales y específicos, así como renovación de licencia oficial colectiva y permanencia. Misma experiencia como docente del centro de formación de esta institución impartiendo materias como  “Ética y Deontología Policial” y "Cadena de Custodia" para los cadetas de la corporación, así como diversos cursos.'
      },
      {
        image:
          'https://d1g6c01s9ssd7h.cloudfront.net/img/perlaRazo.png',
        name: 'Mtra. Perla Razo Martínez',
        education: [
          'Doctorante en Derechos Humanos por el Centro de Estudios Superiores en Ciencias Jurídicas y Criminológicas.',
          'Maestra en Ciencias Penales por la Universidad Mexicana de Educación a Distancia.',
          'Licenciada en Psicología por la UAEM.',
          'Diplomada en Psicología Criminal.',
          'Diplomada en Detección de Mentiras y Lenguaje No Verbal.',
          'Especialista en Psicopatología Social y Psicoanálisis, entre otros.'
        ],
        description:
          'Desde hace más de cinco años se desempeña como Psicóloga penitenciaria (Meritoria) en el Centro Preventivo y de Readaptación Social “Dr. Alfonso Quiroz Cuarón” Texcoco, Edo. Mex. A lo que suma su experiencia como  Psicóloga clínica y evaluadora del Instituto de Administración Pública del Estado de México (IAPEM), programa de intervención en contra del delito y Bullying en escuelas primarias, y como Analista criminal y Psicóloga forense en diversas institucionales federales  y estatales. Su experiencia como docente la ha adquirido en diversas instituciones de educación superior como docente en psicología forense y criminal, a lo largo de más de cinco años.'
      }
    ],
    graduationProfile: [
      {
        description:
          'Los egresados de la MPJF demostrarán los siguientes conocimientos y habilidades:',
        itemsInfo: [
          {
            items: [
              'Conocimientos elementales del derecho, y de los métodos y técnicas de evaluación psicológica, para su aplicación en el ámbito jurídico y forense',
              'Estrategias para la atención a quienes sean objeto de algún delito.',
              'Conocimientos para elaborar perfiles psicológicos, criminológicos y victimológicos en un ámbito forense.',
              'Conocimientos para realizar asesorías con contenido psicológico a personas relacionadas con el ámbito legal; actores jurídicos, operadores judiciales, personas en conflicto con la ley, víctimas, procesados, e instituciones relacionadas con el área.',
              'Características estructurales y dinámicas de la personalidad de las víctimas y victimarios; las conductas desviadas desde un enfoque psicopatológico',
              'Conocimientos en temas de abuso sexual, maltrato, violencia intrafamiliar, daño psíquico y riesgo de peligrosidad.',
              'Habilidades para reconocer los procesos de pensamiento de los individuos y deterioro cognitivo.',
              'Habilidades para desempeñarse en la procuración de justicia e instituciones de rehabilitación social.'
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'Semestre',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Conceptos Básicos de Psicología',
          'Conceptos Básicos del Derecho y del Derecho Penal',
          'Criminología y Conducta Antisocial',
          'Técnicas en Psicología',
          'Victimología'
        ]
      },
      {
        period: '2º',
        periodText: 'Semestre',
        subject: [
          'Psicología Jurídica',
          'Psicología del Interrogatorio y del Testimonio',
          'Mediación y Solución de Conflictos',
          'Técnicas de la Entrevista y Entrevista Jurídica',
          'Evaluación Psicológica'
        ]
      },
      {
        period: '3er',
        periodText: 'Semestre',
        subject: [
          'Psicología Jurídica y Forense',
          'Psicología Criminológica',
          'Psicopatología Descriptiva',
          'Pericial Psicológica',
          'Perfiles Psicológicos y Criminológicos'
        ]
      },
      {
        period: '4º',
        periodText: 'Semestre',
        subject: [
          'La Ética del Psicólogo Jurídico Forense',
          'Intervención Pericial del Psicólogo Jurídico Forense',
          'Técnicas de la Investigación Jurídica y Forense',
          'Evaluación y Psicodiagnóstico Forense',
          'El Informe Pericial y la Práctica Forense'
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/MPJF_2022.pdf'
      }
    ]
  },
  MDPPA: {
    title: 'Maestría en Derecho Procesal Penal Acusatorio (MDPPA)',
    description:
      'Formación en Legalidad y Derechos Humanos que necesita el México contemporáneo',
    users: 300,
    img: 'https://d39ruvey39ymlc.cloudfront.net/files/images/MDPPA_academia.jpg',
    link: 'MDPPA',
    objective: [
      'El objetivo de la Maestría es formar profesionales expertos en el derecho procesal penal acusatorio y oral, con las competencias para aplicar sus conocimientos jurídicos en la solución de problemas concretos propios de la disciplina, dotados de las habilidades argumentativas, interpretativas y valorativas que se requieren, y capaces de privilegiar la protección de los derechos humanos y el Principio Pro Persona.',
      'En la Universidad de las Ciencias nos proponemos el desarrollo y consolidación de expertos en el campo del Nuevo Sistema de Justicia Penal Acusatorio, fortaleciendo aquellas  competencias que les permitan a nuestros egresados conocer y dominar la nueva estructura del Procedimiento Penal y desempeñarse como profesionales de vanguardia  con una visión integral de la Ciencia Jurídica, guiados por la misión  de  fortalecer la Cultura Garantista de Protección a los Derechos Humanos, y con la  disposición y las habilidades de liderazgo que les permitan hacer frente a los desafíos de un mundo cada vez más exigente y en constante transformación.'
    ],
    RVOE: 'RVOE: 2016-094',
    modality: 'Escolarizada',
    duration: 4,
    start: 'Agosto y Febrero',
    subjetcs: 20,
    credits: 75,
    academicGrade:
      'Título de Maestro en Derecho Procesal Penal Acusatorio, registrado ante la SEP.',
    admissionProfile: [
      {
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_018.png',
            text: 'Licenciatura en Derecho, Ciencias Penales, o carreras afines al Derecho.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_021.png',
            text: 'Disposición para la lectura crítica y habilidad para el análisis de las diversas fuentes del derecho.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_004.png',
            text: 'Orientación a la protección de los derechos humanos y la observancia de los principios éticos profesionales. '
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_018.png',
            text: 'Interés por adquirir conocimientos teóricos, dogmáticos y prácticos sobre el derecho procesal penal acusatorio y oral. '
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_019.png',
            text: 'Capacidad para el análisis de casos, el diseño y el desarrollo de estrategias de participación en un proceso penal.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_014.png',
            text: 'Mostrar apertura y disposición al cambio.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_013.png',
            text: 'Habilidad para expresar sus argumentos en forma oral y escrita.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_017.png',
            text: 'Interés por comprender la dinámica de las actuaciones en cada una de las etapas del proceso penal acusatorio y oral.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_015.png',
            text: 'Capacidades para la mediación, la conciliación y la negociación.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_009.png',
            text: 'Actitud asertiva, pensamiento crítico, persuasivo, disposición para estudiar, disposición para promover el conocimiento y uso de mecanismos de solución de controversias, con alta autoestima y habilidades sociales desarrolladas.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_002.png',
            text: 'Disposición para desarrollar habilidades del pensamiento, de la comunicación y sociales a fin de intervenir de manera eficaz en el proceso penal acusatorio y oral. '
          }
        ]
      }
    ],
    graduationProfile: [
      {
        itemsInfo: [
          {
            items: [
              ' El egresado del programa MDPPA de UDC dominará  a profundidad  el  Proceso Penal Acusatorio,  poseerá destrezas y aptitudes que le permitirán ejercer la abogacía con  el más alto estándar de especialización y competitividad; habrá desarrollado habilidades y aptitudes para aplicar las teorías y los principios de vanguardia provenientes del Sistema Jurídico Nacional e Internacional; contará con destrezas y técnicas para conducirse eficazmente en el Proceso Penal Acusatorio, diferenciándose cualitativamente como un Profesional del Derecho.',
              'El egresado del programa MDPPA por la UDC hará de la investigación y la actualización constantes una forma única de ejercer su profesión; integrando la ética jurídica y el respeto y defensa irrestricta a los derechos humanos,  la legalidad, la constitucionalidad,  el principio propersona y la salvaguarda del debido proceso como rasgos destacados de su desempeño profesional.'
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'Semestre',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Antecedentes del Sistema Acusatorio',
          'La Reforma Constitucional en Seguridad Pública',
          'Principios Rectores del Nuevo Sistema de Justicia Procesal Penal',
          'Conceptos Básicos de Derecho Penal',
          'Derecho Procesal Penal en el Sistema Acusatorio'
        ]
      },
      {
        period: '2º',
        periodText: 'Semestre',
        subject: [
          'Sujetos Procesales y otros intervinientes y el Tribunal Superior de Justicia',
          'Argumentación Jurídica',
          'La Etapa de Investigación Desformalizada y Formalizada en el Sistema Acusatorio',
          'Sistema de Audiencias',
          'Etapa Preliminar del Procedimiento Penal Acusatorio'
        ]
      },
      {
        period: '3er',
        periodText: 'Semestre',
        subject: [
          'Los Datos de Prueba, medios de Prueba y las Pruebas en el Sistema Penal Acusatorio',
          'Métodos Alternos de Solución de Controversias y Salidas Alternas al Proceso Penal',
          'Justicia para Adolescentes',
          'Etapa Intermedia del Procedimiento Penal Acusatorio',
          'Derechos Humanos y Derechos Fundamentales'
        ]
      },
      {
        period: '4º',
        periodText: 'Semestre',
        subject: [
          'Etapa de Juicio Oral',
          'Recursos en el Sistema Acusatorio y Amparo Penal',
          'Técnicas de Litigación Oral ',
          'Seminario  de Investigación Jurídica ',
          'Práctica Forense del Procedimiento Penal Acusatorio',
          'Extracurricular: Inglés con fines académicos '
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/MDPPA_2022.pdf'
      }
    ]
  },
  MEPF: {
    title:
      'Maestría Ejecutiva en Evaluación Psicológica Forense (MEPF)',
    description:
      'Fórmate de manera profesional en evaluaciones psicológicas forenses e informes periciales de impacto.',
    users: 300,
    img: 'https://d1g6c01s9ssd7h.cloudfront.net/img/MEPF.jpg',
    link: 'MEPF',
    objective: [
      'Los estudios de la Maestría en Evaluación Psicológica Forense de la Universidad de las Ciencias (UDC) , tienen dos años de duración y están dirigidos a quienes aspiran a desarrollar su trayectoria profesional como líderes de vanguardia en su respectivo campo laboral. A través de este programa, impulsarás el desarrollo y fortalecimiento de tus competencias profesionales y personales, impactando positivamente el entorno. Además desarrollarás habilidades clave para destacar en el ámbito profesional con una experiencia de aprendizaje innovadora y de calidad, acorde a las exigencias del mundo actual. Para lograrlo harás un uso significativo de la tecnología que impulsará tu carrera y te permitirá alcanzar tus objetivos.'
    ],
    RVOE: 'RVOE: 2022-092',
    modality: 'En línea',
    duration: 4,
    start: 'Agosto y Febrero',
    subjetcs: 12,
    credits: 45,
    academicGrade:
      'Título de Ejecutiva en Evaluación Psicológica Forense, registrado ante la SEP',
    admissionProfile: [
      {
        description:
          'El aspirante a ingresar a la Maestría en Evaluación Psicológica Forense de la Universidad de las Ciencias, deberá cumplir los requisitos y reunir las características siguientes:',
        info: [
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_018.png',
            text: 'Licenciatura (o en su defecto, acta de examen profesional o carta de pasante) en Psicología, Psicología clínica, Psicología social, Psicología forense, Psicología educativa, Psicología organizacional, Ciencias del Comportamiento u otras asociadas a la licenciatura en psicología, así como la especialidad en Psiquiatría (Diploma universitario de Médico Psiquiatra o acta de examen profesional).'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_021.png',
            text: 'Interés en la adquisición de conocimiento teórico y práctico de la psicología aplicada en las ciencias jurídicas y forenses.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_002.png',
            text: 'Capacidades de síntesis, análisis y percepción de los detalles, para la mediación, la conciliación y la negociación.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_017.png',
            text: 'Habilidades para asesorar, establecer empatía, realizar entrevistas, para saber reaccionar frente a situaciones extremas, de investigación y para revisar, interpretar y redactar de forma crítica, textos científicos e informes profesionales.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_015.png',
            text: 'Aptitudes favorables para sustentar y defender elementos probatorios y exponerlos de manera persuasiva.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_004.png',
            text: 'Clara orientación a la protección de los derechos humanos y la observancia de los principios éticos profesionales.'
          },
          {
            icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/icon_009.png',
            text: 'Conocimientos teórico-prácticos básicos para el desempeño exitoso de sus actividades profesionales en el campo de las ciencias forenses y periciales.'
          }
        ]
      }
    ],
    graduationProfile: [
      {
        itemsInfo: [
          {
            items: [
              'Dominar el marco teórico de la psicología jurídica y forense, así como el marco normativo del país y la entidad para realizar sus evaluaciones e intervenciones.',
              'Conocer los fundamentos teóricos, manuales de diagnóstico y clasificaciones internacionales de enfermedades que sustentan la labor del psicólogo forense.',
              'Dominar los instrumentos y las pruebas psicométricas que permitirán realizar las evaluaciones de los distintos ámbitos dentro de la psicología forense.',
              'Conducir adecuadamente una entrevista forense, siguiendo protocolos y guías de buenas prácticas aplicables.',
              'Determinar las motivaciones que generan una conducta delictiva y generar programas o acciones preventivas. Así mismo estará capacitado para perfilar o describir las características de la persona que comete un delito.',
              'Utilizar diferentes protocolos y modelos para valorar la validez de un testimonio considerando consistencia, coherencia y contradicciones del mismo.',
              'Conocimientos para realizar asesorías con contenido psicológico a personas relacionadas con el ámbito legal; actores jurídicos, operadores judiciales, personas en conflicto con la ley, víctimas, procesados, e instituciones relacionadas con el área.',
              'Describir, explicar, predecir e intervenir sobre el comportamiento humano que tiene lugar en el contexto jurídico, con la finalidad de contribuir a la construcción y práctica de sistemas jurídicos objetivos y justos.'
            ]
          }
        ]
      }
    ],
    periods: [
      {
        period: '1er',
        periodText: 'Semestre',
        complementary: 'ÁREA BÁSICA',
        subject: [
          'Antecedentes del Sistema Acusatorio',
          'La Reforma Constitucional en Seguridad Pública',
          'Principios Rectores del Nuevo Sistema de Justicia Procesal Penal',
          'Conceptos Básicos de Derecho Penal',
          'Derecho Procesal Penal en el Sistema Acusatorio'
        ]
      },
      {
        period: '2º',
        periodText: 'Semestre',
        subject: [
          'Sujetos Procesales y otros intervinientes y el Tribunal Superior de Justicia',
          'Argumentación Jurídica',
          'La Etapa de Investigación Desformalizada y Formalizada en el Sistema Acusatorio',
          'Sistema de Audiencias',
          'Etapa Preliminar del Procedimiento Penal Acusatorio'
        ]
      },
      {
        period: '3er',
        periodText: 'Semestre',
        subject: [
          'Los Datos de Prueba, medios de Prueba y las Pruebas en el Sistema Penal Acusatorio',
          'Métodos Alternos de Solución de Controversias y Salidas Alternas al Proceso Penal',
          'Justicia para Adolescentes',
          'Etapa Intermedia del Procedimiento Penal Acusatorio',
          'Derechos Humanos y Derechos Fundamentales'
        ]
      },
      {
        period: '4º',
        periodText: 'Semestre',
        subject: [
          'Etapa de Juicio Oral',
          'Recursos en el Sistema Acusatorio y Amparo Penal',
          'Técnicas de Litigación Oral ',
          'Seminario  de Investigación Jurídica ',
          'Práctica Forense del Procedimiento Penal Acusatorio',
          'Extracurricular: Inglés con fines académicos '
        ]
      }
    ],
    downloadFiles: [
      {
        icon: 'https://d1g6c01s9ssd7h.cloudfront.net/img/PDF_icon.png',
        text: 'Folleto informativo',
        link: 'https://d1g6c01s9ssd7h.cloudfront.net/udc/pdf/MEPF_2023.pdf'
      }
    ]
  }
};
